import React from "react";

export const Logo = ({ withWord = true, size = "md", invert = false, withBadge = false, className = "" }) => {
  const sizes = {
    sm: { dot: 36, text: "text-[1.2rem]", badge: "text-[9px]" },
    md: { dot: 48, text: "text-[1.45rem]", badge: "text-[10px]" },
    lg: { dot: 68, text: "text-[1.95rem]", badge: "text-[11px]" },
  };
  const s = sizes[size] || sizes.md;
  return (
    <a
      href="/"
      className={`inline-flex items-center gap-3 ${invert ? "text-white" : "text-ink"} ${className}`}
      data-testid="site-logo"
    >
      <span
        className="relative inline-flex items-center justify-center rounded-full overflow-hidden bg-white ring-1 ring-black/5 shrink-0"
        style={{ width: s.dot, height: s.dot }}
      >
        <img
          src="/calmbreeze-logo.jpg"
          alt="Calmbreeze"
          className="h-[140%] w-[140%] object-cover select-none"
          draggable={false}
          loading="eager"
        />
      </span>
      {withWord && (
        <span className="flex flex-col leading-none">
          <span className={`font-display font-bold tracking-tightest leading-none ${s.text}`}>
            Calmbreeze
          </span>
          {withBadge && (
            <span className={`mt-1.5 font-mono ${s.badge} tracking-overline uppercase whitespace-nowrap ${invert ? "text-white/55" : "text-muted"}`}>
              Est. 2022 · West London
            </span>
          )}
        </span>
      )}
    </a>
  );
};

export default Logo;
